import React from "react";
import i18n from "../../../../variables/translations/i18n";
import { Container } from "reactstrap";
import { Redirect } from "react-router";
import urls from "urls";
import SimpleHeader from "../../../../components/Headers/SimpleHeader";
import {isAdminPage} from "../../../functions/generic";
import AlertWithCancel from "../../../../components/Notifications/AlertWithCancel";
import PaymentLoading from "../../../../components/Loading/payment";
import {
  fetchSubscription,
  updateSubscription,
  upgradeSubscription
} from "../../../functions/stripe/subscription";
import moment from "moment";

class UpgradeSubscription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      companyId: localStorage.getItem("compid"),
      showUpgradeAlert: true,
      proceedWithUpgrade: null,
      upgradeSucceeded: null,
      authorized: this.props.location.authorized,
      subscriptionType: this.props.location.subscriptionType,
      duration: this.props.location.duration,
      priceId: this.props.location.priceId,
      isLoading: false,
    };
  }

  /**
   * Upgrade subscription in Payment API
   */
  confirmUpgradeSubscription() {
    this.setState({proceedWithUpgrade: true, showUpgradeAlert: null, isLoading:true})
    fetchSubscription(this.state.companyId).then((subscription) => {
      upgradeSubscription(subscription.subscriptionId, this.state.priceId)
        .then(() => {
          this.updateSubscription()
          this.setState({isLoading: false, upgradeSucceeded: true})
        })
        .catch(() => this.setState({isLoading: false, upgradeSucceeded: false}))
    })
  }

  /**
   * Update subscription in Firebase
   */
  updateSubscription() {
    let subscription = {
      priceId: this.state.priceId, 
      subscriptionType: this.state.subscriptionType,
      duration: this.state.duration,
      createdAt: moment().unix(),
    }
    updateSubscription(this.state.companyId, subscription)
  }

  render() {
    const { upgradeSucceeded, showUpgradeAlert, authorized, proceedWithUpgrade, isLoading } = this.state;
    if (upgradeSucceeded === true) return <Redirect to={{pathname: urls.subscription, paymentDone: true}} />;
    if (upgradeSucceeded === false) return <Redirect to={{pathname: urls.subscription, paymentDone: false}} />;
    if (!authorized || proceedWithUpgrade === false) return <Redirect to={{pathname: urls.subscription}} />;
    return (
      <>
        <SimpleHeader
          name={i18n.t("dashboard.abonnement.abonnement_titel")}
          parentName={i18n.t("dashboard.bedrijf")}
          isAdminPage={isAdminPage(this.props.location.pathname)}
        />
        <Container className="mt--8 pb-5">
          {isLoading &&
          <PaymentLoading/>
          }
          {showUpgradeAlert &&
          <AlertWithCancel
            type="info"
            title={i18n.t("dashboard.abonnement.upgraden_bevestigings_vraag_titel")}
            description={i18n.t("dashboard.abonnement.upgraden_bevestigings_vraag_descr")}
            confirmBtnText={i18n.t("dashboard.abonnement.abonnement_upgraden_btn")}
            confirmAlert={() => this.confirmUpgradeSubscription()}
            closeAlert={() => this.setState({proceedWithUpgrade: false, showUpgradeAlert: null})}
            cancelBtnText={i18n.t("dashboard.sluiten")}
          />
          }
        </Container>
      </>
    );
  }
}

export default UpgradeSubscription;
